import _ from 'lodash'
import moment from 'moment-mini'
import { WEEK_LABELS } from '../constants'
import DateCell from '../DateCell'

export default {
  provide() {
    return {
      context: this,
    }
  },
  props: {
    weekStartDay: {
      type: Number,
      default: 7,
    },
    value: {
      type: moment,
    },
  },
  data() {
    return {
      hoveredCell: null,
    }
  },
  computed: {
    weekLabels() {
      return [...WEEK_LABELS, ...WEEK_LABELS].slice(this.weekStartDay, this.weekStartDay + 7)
    },
    startOfMonth() {
      return this.value.clone().startOf('month')
    },
    startDayOfWeek() { // 所属月的第一天是星期几
      return this.startOfMonth.day()
    },
    viewStartDate() {
      let offset = this.startDayOfWeek - this.weekStartDay
      offset = offset > 0 ? offset : 7 + offset
      offset = offset === 0 ? 7 : offset

      return this.startOfMonth.clone().subtract(offset, 'd')
    },
    viewStartWeekOfYear() {
      return this.viewStartDate.week()
    },
    weeks() {
      const weeks = [{}, {}, {}, {}, {}, {}]
      let offset = 0
      for (let i = 0; i < weeks.length; i++) {
        const week = {
          week: this.viewStartWeekOfYear + i,
          dates: [],
        }
        for (let j = 0; j < 7; j++) {
          week.dates.push(this.viewStartDate.clone().add(offset, 'd'))
          offset++
        }

        weeks[i] = week
      }
      return weeks
    },
  },
  methods: {
    renderWeekLabels() {
      return (
        <div class="km-calendar__week-labels">
          {
            _.map(this.weekLabels, label => (
              <div>
                {label}
              </div>
            ))
          }
        </div>
      )
    },
    handleCellClick(cell) {

    },
    handleCellHover(cell) {
      this.hoveredCell = cell
    },
    handleCellLeave() {
      this.hoveredCell = null
    },
  },
  render() {
    const css = {
      'km-calendar__view': true,
    }

    const data = {
      class: css,
    }

    return (
      <div {...data}>
        <div class="km-calendar__grid">
          {this.renderWeekLabels()}
          {
            _.map(this.weeks, (week, index) => (
              <div
                class="km-calendar__row"
                weekOfYear={this.viewStartWeekOfYear + index}
              >
                {

                  _.map(week.dates, date => (
                    <DateCell
                      referenceValue={this.value}
                      value={date}
                    />
                    //   <div class="km-calendar__cell">
                    //     <div
                    //       class="km-calendar__date"
                    //     >
                    //       <div class="km-calendar__value">
                    //         {date.format('D')}
                    //       </div>
                    //       <div class="km-calendar__content">
                    //       </div>
                    //     </div>
                    //   </div>
                  ))
                }
              </div>
            ))
          }
        </div>
      </div>
    )
  },
}
